import { survey as api } from '@/api'

const loadSurvey = async ({ commit, state }) => {
  return new Promise(async (resolve, reject) => {
    commit('LOADING_UPDATED', true)
    try {
      let survey = (await api.fetchSurvey(state.surveyKey)).data
      let questions = []
      let answerPacks = []

      survey.questions.forEach(question => {
        let answerPack = { answers: [] }

        answerPack.questionId = question.id
        question.answers.forEach(answer => {
          answerPack.answers.push(answer)
        })
        answerPacks.push(answerPack)
        delete question.answers
        questions.push(question)
      })
      delete survey.questions

      commit('SURVEY_UPDATED', survey)
      commit('QUESTIONS_UPDATED', questions)
      commit('ANSWERPACKS_UPDATED', answerPacks)
      commit('ERROR_UPDATED', false)
      resolve()
    } catch (error) {
      commit('ERROR_UPDATED', true)
      reject(new Error(error))
    } finally {
      commit('LOADING_UPDATED', false)
    }
  })
}

const vote = async ({ state, commit, dispatch }, userVotes) => {
  // Save answers
  await api.incrementVotesCount(state.surveyKey, userVotes)
  try {
    localStorage[`iDalgoSurvey-${state.survey.id}`] = JSON.stringify(userVotes)
  } catch (e) {}
  commit('USER_VOTES_UPDATED', userVotes)
  dispatch('loadSurvey')
}

const getAverageVotesCount = async ({ state, commit }) => {
  const votesCounts = await api.fetchAverageVotesCount(state.questions[state.currentQuestion].id)
  let totalValue = 0
  let totalVotesCount = 0

  votesCounts.data.forEach(item => {
    totalValue += Number(item.value) * item.count
    totalVotesCount += item.count
  })
  let AverageVotesCount = totalValue / totalVotesCount
  commit('AVERAGEVOTECOUNT_UPDATED', Math.floor(AverageVotesCount * 10) / 10)
  commit('TOTALVOTECOUNT_UPDATED', totalVotesCount)
}

export default {
  loadSurvey,
  vote,
  getAverageVotesCount
}
